export default {"src":"/_next/static/media/yahoo-dark.e56f4a87.svg","height":44,"width":119,"blurWidth":0,"blurHeight":0};